import { useState } from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { Logo } from "@/components/navbar";
import CookieSettings from "@/components/cookiesettings";

const linkCls = "text-sm text-[#94A3B8] hover:text-white transition-colors duration-200 w-fit";
const headCls = "font-mono-accent text-xs font-semibold tracking-[0.22em] uppercase text-[#FF5E1A] mb-5";

const Footer = () => {
  const [cookiesOpen, setCookiesOpen] = useState(false);

  return (
    <footer className="bg-[#0B132B]" data-testid="site-footer">
      <div className="container-nb py-16 md:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-4">
          <Link to="/" aria-label="NicheBytes home" className="inline-block">
            <Logo />
          </Link>
          <p className="mt-5 font-display text-base font-semibold text-white">Tech Talent. Zero Guesswork.</p>
          <p className="mt-2 text-sm text-[#94A3B8] leading-relaxed max-w-xs">
            Boutique technical recruitment for Cybersecurity, Cloud and Software Engineering teams
            across the Netherlands and Europe.
          </p>
        </div>
        <div className="lg:col-span-2 lg:col-start-6">
          <p className={headCls}>Company</p>
          <div className="flex flex-col gap-3">
            {[["/", "Home"], ["/about", "About"], ["/employers", "Employers"], ["/candidates", "Candidates"], ["/services", "Our Services"]].map(([to, label]) => (
              <Link key={label} to={to} className={linkCls}>{label}</Link>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className={headCls}>Get In Touch</p>
          <div className="flex flex-col gap-3">
            <Link to="/contact" className={linkCls}>Book a Discovery Call</Link>
            <a href="mailto:sarithajain@nichebytes.nl" className={linkCls} data-testid="footer-email">sarithajain@nichebytes.nl</a>
            <a href="https://www.linkedin.com/in/sarithajain" target="_blank" rel="noopener noreferrer" className={`${linkCls} inline-flex items-center gap-2.5`} data-testid="footer-linkedin-saritha">
              <Linkedin size={15} className="text-[#FF5E1A]" /> Saritha Jain
            </a>
            <a href="https://www.linkedin.com/company/niche-bytes/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className={`${linkCls} inline-flex items-center gap-2.5`} data-testid="footer-linkedin-nichebytes">
              <Linkedin size={15} className="text-[#FF5E1A]" /> NicheBytes
            </a>
          </div>
        </div>
        <div className="lg:col-span-2">
          <p className={headCls}>Legal</p>
          <div className="flex flex-col gap-3">
            <Link to="/privacy" className={linkCls} data-testid="footer-privacy">Privacy Policy</Link>
            <button onClick={() => setCookiesOpen(true)} className={`${linkCls} text-left`} data-testid="footer-cookies">Cookie Preferences</button>
          </div>
        </div>
      </div>
      <div className="border-t border-[#1E293B]">
        <div className="container-nb py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-sm text-[#64748B]">Specialist Cybersecurity &amp; IT Engineering Talent Partner · Utrecht, Netherlands</p>
          <p className="text-sm text-[#64748B]">© 2026 NicheBytes</p>
        </div>
      </div>
      <CookieSettings open={cookiesOpen} onClose={() => setCookiesOpen(false)} />
    </footer>
  );
};

export default Footer;
